'use client'

import {
  ChatTeardropIcon,
  DotsThreeOutlineIcon,
  DownloadSimpleIcon,
  HeartIcon,
  ShareFatIcon
} from '@phosphor-icons/react'
import { Ring2 } from 'ldrs/react'

import { RemixIcon } from '@/components/icons'
import { LikeStatus } from '@/enums/const'
import { useCountFormat } from '@/hooks'
import { useVideoDownload } from '@/hooks/utils'
import { Link } from '@/i18n/navigation'
import { useLikeWork, useUnlikeWork } from '@/lib/api/hooks/social'
import { cn } from '@/lib/utils'

import { MobileCommentsPanel } from '../comments'
import { useWorkContext } from '../work-context'
import { WorkDetailsDrawer } from '../work-details'

import { ShareDrawer } from './share-drawer'

export const WorkActionSide = ({ className }: { className?: string }) => {
  const format = useCountFormat()
  const { data, setSkipReset } = useWorkContext()

  const [isDownloading, downloadVideo] = useVideoDownload()

  const likeMutation = useLikeWork(data?.jobId || '')
  const unlikeMutation = useUnlikeWork(data?.jobId || '')

  const isLiked = data?.isLike === LikeStatus.LIKE

  const handleLike = () => {
    if (!data?.jobId) return

    if (isLiked) {
      unlikeMutation.mutate(data.jobId)
    } else {
      likeMutation.mutate(data.jobId)
    }
  }

  const handleDownload = () => {
    if (!data?.videoUrl) return
    downloadVideo(data.videoUrl)
  }

  return (
    <div className={cn('flex h-full flex-col items-center justify-center gap-2 pr-2', className)}>
      <button
        className="pointer-events-auto flex h-auto w-10 flex-col items-center justify-center gap-2 rounded-full p-2 text-white"
        onClick={handleLike}
      >
        <HeartIcon className="size-[26px]" strokeWidth={2} weight={isLiked ? 'fill' : 'bold'} />
        <span className="text-sm">{format(data?.likeCount)}</span>
      </button>
      <MobileCommentsPanel>
        <button className="pointer-events-auto flex h-auto w-10 flex-col items-center justify-center gap-2 rounded-full p-2 text-white">
          <ChatTeardropIcon className="size-[26px]" strokeWidth={2} weight="bold" />
          <span className="text-sm">{format(data?.commentCount)}</span>
        </button>
      </MobileCommentsPanel>
      <ShareDrawer>
        <button className="pointer-events-auto flex h-auto w-10 flex-col items-center justify-center gap-2 rounded-full p-2 text-white">
          <ShareFatIcon className="size-[26px]" strokeWidth={2} weight="bold" />
        </button>
      </ShareDrawer>
      <WorkDetailsDrawer>
        <button className="pointer-events-auto flex h-auto w-10 flex-col gap-2 rounded-full p-2 text-white">
          <DotsThreeOutlineIcon className="size-[26px]" strokeWidth={20} weight="fill" />
        </button>
      </WorkDetailsDrawer>
      <button
        className="pointer-events-auto flex aspect-square w-10 items-center justify-center rounded-full"
        disabled={isDownloading}
        onClick={handleDownload}
      >
        {isDownloading ? (
          <Ring2 color="white" size={24} stroke={2} />
        ) : (
          <DownloadSimpleIcon className="size-[26px]" weight="bold" />
        )}
      </button>
      <Link
        className="pointer-events-auto flex size-12 items-center justify-center"
        href="/space"
        onClick={() => setSkipReset?.(true)}
      >
        <RemixIcon />
      </Link>
    </div>
  )
}
